import { Component, OnInit } from '@angular/core';
import { HelpersService } from '../../../../services/helpers.service';
import { PosIntegrationService } from '../../../../services/pos-integration.service';
import { PaymentService } from '../../../../services/payment.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-service-deposit-configuration',
  templateUrl: './service-deposit-configuration.component.html',
  styleUrls: ['./service-deposit-configuration.component.scss'],
})
export class ServiceDepositConfigurationComponent implements OnInit {
  public partner: any = {};
  public isStipeIntegrated: boolean = false;
  public isPOSPaymentsSupported: boolean = false;
  public DepositConfigForm: FormGroup = null;
  public depositConfiguration: any = {};
  public busy: boolean = false;
  public loading: boolean = false;
  public serviceTypes: any = [];

  public modules = {
    toolbar: [
      ['bold', 'italic', 'underline'], // toggled buttons
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      ['clean'], // remove formatting button
    ],
  };

  constructor(
    private fb: FormBuilder,
    private helpersService: HelpersService,
    private posIntegrationService: PosIntegrationService,
    private paymentService: PaymentService,
    private translate: TranslateService,
    private messageService: MessageService,
  ) {}

  ngOnInit() {
    this.loading = true;
    this.partner = this.helpersService.getPartnerData();
    this.checkIfLinkedToStripeConnect();
    this.getServiceDepositConfig();
  }

  getServiceDepositConfig() {
    this.loading = true;
    this.paymentService
      .getServiceDepositConfig(this.partner.ID)
      .subscribe((depositConfiguration) => {
        this.depositConfiguration = depositConfiguration;
        this.setupValidation();
        this.setupServiceTypes();
        this.checkPOSPaymentsSupported();
        this.loading = false;
      });
  }

  setupServiceTypes() {
    this.serviceTypes = [];
    var groupName = '';
    this.depositConfiguration.serviceTypes
      .sort((x, y) => {
        return x.groupOrder - y.groupOrder || x.groupName - y.groupName;
      })
      .map((serviceType) => {
        serviceType.groupName = serviceType.groupName
          ? serviceType.groupName
          : this.translate.instant('general.not_grouped');
        if (serviceType.groupName !== groupName) {
          groupName = serviceType.groupName;
          this.serviceTypes.push({
            label: serviceType.groupName,
            value: -1,
            disabled: true,
            search: '',
            reverseSearch: '',
          });
        }
        var words = serviceType.serviceTypeDescription.split(' ');
        var reverseSearch = [];
        if (words) {
          words.forEach((word) => {
            reverseSearch.unshift(word);
          });
        }
        this.serviceTypes.push({
          label: serviceType.serviceTypeDescription,
          value: serviceType.id,
          search: serviceType.serviceTypeDescription,
          reverseSearch: reverseSearch.join(' '),
        });
      });

    console.log(this.serviceTypes);
  }

  setupValidation() {
    this.DepositConfigForm = this.fb.group({
      paymentOnCheckout: new FormControl(
        this.depositConfiguration.paymentOnCheckout,
        Validators.required,
      ),
      fullPaymentOrDeposit: new FormControl(
        this.depositConfiguration.fullPaymentOrDeposit,
        Validators.nullValidator,
      ),
      depositPercentOrFixed: new FormControl(
        this.depositConfiguration.depositPercentOrFixed,
        Validators.nullValidator,
      ),
      depositValue: new FormControl(
        this.depositConfiguration.depositValue,
        Validators.nullValidator,
      ),
      minimumValue: new FormControl(
        this.depositConfiguration.minimumValue || 0.0,
        Validators.nullValidator,
      ),
      paymentTermsAndConditions: new FormControl(
        this.depositConfiguration.paymentTermsAndConditions || '',
        Validators.nullValidator,
      ),
      allServiceTypes: new FormControl(
        this.depositConfiguration.allServiceTypes,
        Validators.required,
      ),
      linkedServices: new FormControl(
        this.depositConfiguration.linkedServices,
        Validators.nullValidator,
      ),
    });

    this.DepositConfigForm.get('paymentOnCheckout').valueChanges.subscribe(
      (value) => {
        if (value) {
          this.DepositConfigForm.get('fullPaymentOrDeposit').setValidators(
            Validators.required,
          );
        } else {
          this.DepositConfigForm.get('fullPaymentOrDeposit').setValidators(
            Validators.nullValidator,
          );
          this.DepositConfigForm.get('depositPercentOrFixed').setValidators(
            Validators.nullValidator,
          );
          this.DepositConfigForm.get('depositValue').setValidators(
            Validators.nullValidator,
          );
        }
      },
    );
    this.DepositConfigForm.get('fullPaymentOrDeposit').valueChanges.subscribe(
      (value) => {
        if (value === 'DEPOSIT') {
          this.DepositConfigForm.get('depositPercentOrFixed').setValidators(
            Validators.required,
          );
          this.DepositConfigForm.get('depositValue').setValidators(
            Validators.required,
          );
        } else {
          this.DepositConfigForm.get('depositPercentOrFixed').setValidators(
            Validators.nullValidator,
          );
          this.DepositConfigForm.get('depositValue').setValidators(
            Validators.nullValidator,
          );
        }
      },
    );
    this.DepositConfigForm.get('depositPercentOrFixed').valueChanges.subscribe(
      (value) => {
        if (value) {
          this.DepositConfigForm.get('depositValue').setValidators(
            Validators.required,
          );
        } else {
          this.DepositConfigForm.get('depositValue').setValidators(
            Validators.nullValidator,
          );
        }
      },
    );
  }

  checkIfLinkedToStripeConnect() {
    this.paymentService
      .checkPartnerLinkedStripeConnect(this.partner.ID)
      .subscribe(
        (result) => {
          this.isStipeIntegrated = result && result.linked;
        },
        (error) => {
          this.isStipeIntegrated = false;
        },
      );
  }

  checkPOSPaymentsSupported() {
    if(this.partner.POSSystemID == 6 || this.partner.POSSystemID == 3 || this.partner.POSSystemID == 12 || this.partner.POSSystemID == 19 || this.partner.POSSystemID <= 0){
      this.isPOSPaymentsSupported = true;
    } else if (this.partner.POSSystemID == 9) {
      this.posIntegrationService
        .getShopifyConfig(this.partner.ID)
        .subscribe((res) => {
          if (!res.UseDraftOrders) {
            this.isPOSPaymentsSupported = true;
          } else {
            this.isPOSPaymentsSupported = false;
            this.DepositConfigForm.get('paymentOnCheckout').setValue(false);
          }
        });
    } else {
      this.isPOSPaymentsSupported = false;
      this.DepositConfigForm.get('paymentOnCheckout').setValue(false);
    }
  }

  saveConfig(depositData) {
    console.log(this.depositConfiguration);
    console.log(depositData);
    var data = { ...this.depositConfiguration, ...depositData };
    this.busy = true;
    this.paymentService.updateServiceDepositConfig(data).subscribe(
      (res) => {
        this.messageService.add({
          life: 5000,
          key: 'service-deposit-config',
          detail: this.translate.instant(
            'bikeshop.rentals.configuration.updated_configuration',
          ),
          closable: false,
        });
        this.busy = false;
      },
      (err) => {
        this.busy = false;
      },
    );
  }
}
